<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";

import SubastaLotes from "./SubastaLotes/SubastaLotes.vue";
import SubastaPortada from "./SubastaPortada.vue";
import SpinnerLoader from "@/components/Spinner/SpinnerLoader.vue";

import { useLotesSubastaStore } from "@/store/lotesSubastaStore";
import { useListadosEntidadesStore } from "@/store/listadosEntidadesStore";
import { useUsuarioStore } from "@/store/usuarioStore";
import SubastaPestanias from "./SubastaPestanias/SubastaPestanias.vue";
import { Modal } from "bootstrap";
import SinMartilleroModal from "./SinMartilleroModal.vue";
import { getCookie, setCookie } from "@/utils/cookies";

import {
  abandonarCanalDeSubastas,
  suscribirACanalDeSubastas,
} from "@/realtime/canalEventosSubastas.js";

const LotesSubastaStore = useLotesSubastaStore();
const listadosEntidadesStore = useListadosEntidadesStore();
const sinMartilleroModalRef = ref(null);
const loading = ref(true);
const route = useRoute();

const closeModal = () => {
  sinMartilleroModalRef.value.hide();
}

const usuarioStore = useUsuarioStore()

onMounted(async () => {
  const cookie = getCookie('popup_visto');
  if (!cookie) {
    
    const ahora = new Date()
    const manana = new Date(ahora)
    manana.setHours(24, 0, 0, 0) // próxima medianoche
    setCookie('popup_visto', true, manana)
    
    sinMartilleroModalRef.value = new Modal(document.getElementById('sin-martillero-modal'),
    { backdrop: "static", keyboard: false })
    sinMartilleroModalRef.value.show();
  }  
  if (route.query.subastaId) {
    try {
      await LotesSubastaStore.obtenerSubastaConLotes(route.query.subastaId);
      
      suscribirACanalDeSubastas(LotesSubastaStore.auction, (event) => {
        LotesSubastaStore.aplicarPujaActualizada(event);
      });
      await listadosEntidadesStore.getCategoriasTipificados(route.query.subastaId);
    } catch (error) {
      console.error("Error al cargar la subasta:", error);
    } finally {      
      loading.value = false;
    }
  } else {
    loading.value = false;
  }
});
onBeforeUnmount(() => {
  abandonarCanalDeSubastas();
});


</script>

<template>
  <main>
    <div v-if="loading" class="spinner-overlay">
      <SpinnerLoader size="64px" />
    </div>

    <div v-else>
      <SubastaPortada :LotesSubastaStore="LotesSubastaStore" />

    <!-- Listado de lotes -->
      <div class="container mt-4 p-4" style="padding: 0 !important;">
        <div class="row">
          <div class="col-md-12">
            <SubastaLotes
              :LotesSubastaStore="LotesSubastaStore"
              :listadosEntidadesStore="listadosEntidadesStore"
            />
          </div>
        </div>
        <SubastaPestanias :LotesSubastaStore="LotesSubastaStore" :usuarioStore="usuarioStore"/>
      </div>
    </div>
    <SinMartilleroModal @closeModal="closeModal"/>
  </main>
</template>

<style>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
